module.exports = "/next-static/_next/static/images/block_image_two_1x-f993cb459fc965608f5692a69cee2c1b.webp";